import _classCallCheck from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { getNullLogger, getSubscriptionManager } from '@uniformdev/common';
import { getSitecorePersonalizationRuleManager } from '../ruleManagers/sitecore';
import { getSitecoreContextDataReader } from './contextReaders';
;
;
/**
 * Gets a Sitecore personalization manager.
 * @param args
 */
export function getSitecorePersonalizationManager(args) {
  var _a;
  //
  //Get data from context
  var reader = getSitecoreContextDataReader(args.contextDataSource);
  var definitions = reader === null || reader === void 0 ? void 0 : reader.getDefinitions(args.contextData);
  var item = reader === null || reader === void 0 ? void 0 : reader.getPageDetails(args.contextData);
  var testManager = (_a = args.testManager) !== null && _a !== void 0 ? _a : {
    disabled: false,
    getIsIncludedInTest: function getIsIncludedInTest() {
      return false;
    }
  };
  var args2 = {
    definitions: definitions,
    item: item,
    logger: args.logger
  };
  var ruleManager = getSitecorePersonalizationRuleManager(args2);
  var settings = {
    disabled: args.disabled,
    item: item,
    logger: args.logger,
    ruleManager: ruleManager,
    testManager: testManager
  };
  return new SitecorePersonalizationManager(settings);
}
/**
 * Sitecore personalization manager.
 */
var SitecorePersonalizationManager = /*#__PURE__*/function () {
  function SitecorePersonalizationManager(settings) {
    _classCallCheck(this, SitecorePersonalizationManager);
    var _a, _b, _c;
    this.disabled = (_a = settings === null || settings === void 0 ? void 0 : settings.disabled) !== null && _a !== void 0 ? _a : false;
    this.logger = (_b = settings === null || settings === void 0 ? void 0 : settings.logger) !== null && _b !== void 0 ? _b : getNullLogger();
    this.page = settings === null || settings === void 0 ? void 0 : settings.item;
    this.ruleManager = settings === null || settings === void 0 ? void 0 : settings.ruleManager;
    this.subscriptions = getSubscriptionManager();
    this.testManager = settings === null || settings === void 0 ? void 0 : settings.testManager;
    this.triggers = (_c = settings === null || settings === void 0 ? void 0 : settings.ruleManager) === null || _c === void 0 ? void 0 : _c.triggers;
  }
  return _createClass(SitecorePersonalizationManager, [{
    key: "onTrigger",
    value: function onTrigger(trigger, rendering) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.doPersonalize(rendering, [trigger]);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "personalize",
    value: function personalize(rendering) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.doPersonalize(rendering);
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "doPersonalize",
    value: function doPersonalize(rendering, triggers) {
      var _a, _b;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var rules, rule, result, includedInTest;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (rendering) {
                _context3.next = 3;
                break;
              }
              this.logger.error('Sitecore personalization manager - No rendering was specified.');
              return _context3.abrupt("return");
            case 3:
              if (!this.disabled) {
                _context3.next = 6;
                break;
              }
              this.logger.debug('Sitecore personalization manager - Personalization is disabled.');
              return _context3.abrupt("return");
            case 6:
              if (this.ruleManager) {
                _context3.next = 9;
                break;
              }
              this.logger.debug('Sitecore personalization manager - No rule manager is configured.');
              return _context3.abrupt("return");
            case 9:
              rules = this.ruleManager.getRulesForRendering(rendering);
              if (!(!rules || rules.length == 0)) {
                _context3.next = 13;
                break;
              }
              this.logger.debug('Sitecore personalization manager - No rules were resolved for the rendering.', {
                rendering: rendering
              });
              return _context3.abrupt("return");
            case 13:
              //
              //Set to loading before applying the rules
              this.subscriptions.publish({
                component: rendering.uid,
                isLoading: true,
                page: this.page,
                type: 'state-changed',
                when: new Date()
              });
              _context3.prev = 14;
              _context3.next = 17;
              return this.ruleManager.getFirstMatchingRule(rendering, triggers);
            case 17:
              rule = _context3.sent;
              if (rule) {
                _context3.next = 22;
                break;
              }
              this.logger.debug('Sitecore personalization manager - No personalization rule found that applies to the rendering.', {
                rendering: rendering
              });
              this.subscriptions.publish({
                component: rendering.uid,
                isLoading: false,
                page: this.page,
                type: 'state-changed',
                when: new Date()
              });
              return _context3.abrupt("return");
            case 22:
              this.logger.debug('Sitecore personalization manager - Will run the actions associated with the rule.', {
                rule: rule,
                rendering: rendering
              });
              _context3.next = 25;
              return this.ruleManager.runRuleActions(rule, rendering);
            case 25:
              result = _context3.sent;
              includedInTest = (_b = (_a = this.testManager) === null || _a === void 0 ? void 0 : _a.getIsIncludedInTest()) !== null && _b !== void 0 ? _b : false; //
              //Publish a state-changed event to notify components that
              //personalization is done loading and that there may be
              //changes to render.
              this.logger.debug('Sitecore personalization manager - Result of running the rule actions.', {
                result: result,
                rule: rule,
                rendering: rendering
              });
              this.subscriptions.publish({
                changes: result.changes,
                component: rendering.uid,
                includedInTest: includedInTest,
                isLoading: false,
                page: this.page,
                personalizedData: result.fields,
                rule: rule,
                type: 'state-changed',
                when: new Date()
              });
              _context3.next = 35;
              break;
            case 31:
              _context3.prev = 31;
              _context3.t0 = _context3["catch"](14);
              this.subscriptions.publish({
                component: rendering.uid,
                error: _context3.t0,
                isLoading: false,
                page: this.page,
                type: 'state-changed',
                when: new Date()
              });
              return _context3.abrupt("return");
            case 35:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[14, 31]]);
      }));
    }
  }]);
}();